<script>
  export let location;
  import Hero from "../components/Hero.svelte";
  import Featured from "../components/Machines/Featured.svelte";
  import { link } from "svelte-routing";
  //Featured Machines

  //Functions
  function getLinkProps() {
    return { class: "btn btn-primary btn-hero" };
  }
</script>

<h1>ESTAMOS TRABAJANDO EN ESTE SITIO</h1>
